/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseDoctorDto } from '../../models/response-doctor-dto';
import { UpdateDoctorDto } from '../../models/update-doctor-dto';

export interface DoctorsControllerUpdate$Params {

/**
 * The tenant of the doctor
 */
  tenant: string;

/**
 * The doctor id
 */
  id: string;
      body: UpdateDoctorDto
}

export function doctorsControllerUpdate(http: HttpClient, rootUrl: string, params: DoctorsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseDoctorDto>> {
  const rb = new RequestBuilder(rootUrl, doctorsControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseDoctorDto>;
    })
  );
}

doctorsControllerUpdate.PATH = '/thalea-doctors/doctors/{tenant}/{id}';
